import { Placement, DeviceFamily } from '@amzn/fire-tv-campaign-automation-service';

import { FIRE_TABLET_FEATURE_ROTATOR_CONFIG } from './previewConfigurations/FireTablets/fireTabletFeatureRotatorConfiguration';
import { FIRE_TV_FEATURE_ROTATOR_CONFIG } from './previewConfigurations/FireTV/fireTVFeatureRotatorConfiguration';
import { FIRE_TV_SCREEN_SAVER_CONFIG } from './previewConfigurations/FireTV/fireTVScreenSaverConfiguration';
import { PreviewConfigBase } from './previewConfigurations/types';

export const DEVICE_FAMILY_PREVIEW_CONFIG: Partial<
  Record<DeviceFamily, Partial<Record<Placement, PreviewConfigBase>>>
> = {
  [DeviceFamily.FIRE_TV]: {
    [Placement.FEATURE_ROTATOR]: FIRE_TV_FEATURE_ROTATOR_CONFIG,
    [Placement.SCREEN_SAVER]: FIRE_TV_SCREEN_SAVER_CONFIG,
  },
  [DeviceFamily.FIRE_TABLETS]: {
    [Placement.FEATURE_ROTATOR]: FIRE_TABLET_FEATURE_ROTATOR_CONFIG,
  },
};

/**
 * Get preview configuration for a specific placement and device family.
 * Feature flag filtering (e.g. hiding the Device Preview tab for non-US marketplaces)
 * is handled at the component level via useFeatureFlag, not here.
 */
export function getPreviewConfig(
  placement: Placement,
  deviceFamily: DeviceFamily = DeviceFamily.FIRE_TV,
): PreviewConfigBase {
  const config = DEVICE_FAMILY_PREVIEW_CONFIG[deviceFamily]?.[placement];

  if (!config) {
    throw new Error(
      `No preview configuration found for placement: ${placement}, deviceFamily: ${deviceFamily}`,
    );
  }

  return config;
}
